// extracted by mini-css-extract-plugin
export var deliveryRow = "_sp-a";
export var fixedHeight = "_sp-4";
export var freightLogo = "_sp-9";
export var fullWidth = "_sp-3";
export var priceColumn = "_sp-5";
export var radioSelected = "_sp-7";
export var radioUnselected = "_sp-6";
export var selectedOption = "_sp-2";
export var selectedOptionContainer = "_sp-1";
export var selection = "_sp-0";
export var tallSkeletonText = "_sp-8";